
<!-- Modal for an user successful manual acceptence -->
<ng-template #successfulManualAcceptence>
      
    <div class="modal-header modal-header-custom">
        <div class="flex justify-content-space-between pt-2">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'manualValidation.lblTitle' | translate }}
            </span>
            <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
        </div>
        <hr class="line-h-blue-purple-dialogs">
    </div>
  
    <div class="row modal-row-body-total mr-3 ml-3 w-95-p max-h-80-p">
  
        <br>
  
        <div class="col-md-12 top-margin-align-start scroll-panel">
  
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="row mt-4">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="d-block" [ngClass]="(txtReason?.value)?'has-value':''">
                            <textarea matInput maxlength="255"  id="txtReason" formControlName="txtReason" 
                                [placeholder]="('common.lblDescription' | translate) + '*'"></textarea>
                            <mat-hint>{{txtReason.value.length}} / 255</mat-hint>
                        </mat-form-field>
                        <mat-error class="p-error float-left" *ngIf="txtReason.hasError('required') && (txtReason.dirty || txtReason.touched)">
                            {{ 'common.lblErrorRequired' | translate}}
                        </mat-error>
                    </div>
                </div>

                <br>

                <div class="modal-footer z-index-9999">
                    <div class="row w-100-p justify-content-space-between">
                        <button type="button" (click)="cancel()" class="btn btn-secondary mr-1">
                            {{ 'common.btnCancel' | translate}}
                        </button>
                        <button type="submit" class="btn btn-primary m-b-10" [disabled]="form.invalid">
                            {{ 'common.btnSave' | translate}}
                        </button>
                    </div>
                  </div>
            </form>
  
        </div>
  
    </div>
          
</ng-template>
